// Angular
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'kt-fetch-entity-dialog',
	standalone: true,
	imports: [
		CommonModule,
		MatDialogModule,
		MatButtonModule,
		TranslateModule
	],
	templateUrl: './fetch-entity-dialog.component.html'
})
export class FetchEntityDialogComponent {
	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<FetchEntityDialogComponent>,
	 * @param data: any
	 */
	constructor(
		public dialogRef: MatDialogRef<FetchEntityDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/** UI */
	/**
	 * Returns CSS Class Name by status type
	 * @param status: number
	 */
	getItemCssClassByStatus(status: number = 0) {
		switch (status) {
			case 0: return 'success';
			case 1: return 'metal';
			case 2: return 'danger';
			default: return 'success';
		}
	}
}
